import EzButtonGroup from '@/components/ui/Button/EzButtonGroup.vue';

export { default } from './EzButton.vue';
export {
  EzButtonGroup,
};
